import React, {Component} from 'react';
import Modal from '../../../../../../../../components-new/ui/Modal';

import Translate from "../../../../../../../../components/Translate";
import {deleteWebhook} from "../../../../../../../../services/company/api";
import config from "../../../../../../../../config";
import TableAction from "../../../../../../../../components-new/table/TableAction";
import DeleteIcon from "../../../../../../../../assets/icons/DeleteIcon";
import colors from "../../../../../../../../utils/Colors";
import WebhookLogs from "./WebhookLogs";
import WebhookTypeChip from "./WebhookTypeChip";
import ChevronLeftIcon from "../../../../../../../../assets/icons/ChevronLeftIcon";
import {generalModalStyles} from "../../../../../../../../utils/General";
import TableScroll from "../../../../../../../../components-new/table/TableScroll";
import Tooltip from "../../../../../../../../components-new/general/Tooltip";
import './WebhooksModal.css';

const styles = {
    /*
     * The look comes from .custom-table now. These were inline, which outranks
     * any stylesheet, so this table kept the old dark blue header after every
     * other one had changed.
     */
    table: {
        width: '100%',
    },
    th: {},
    td: {},
    parentTableDiv: {
        maxHeight: '295px',
        overflow: 'auto'
    },
};


Modal.setAppElement('#root');

class WebhooksModal extends Component {
    /* which webhook's calls are being read, if any */
    state = {logsFor: null};

    render() {
        let {
            isOpen,
            cancelAction,
            webhooks,
            updateWebhooksState,
            setUpdateWebhooksState,
            webhooksData,
            addNotification
        } = this.props;

        const {logsFor} = this.state;

        return (
            <Modal footer={null} closeTimeoutMS={config.closeTimeoutMS}
                   isOpen={isOpen}
                   style={generalModalStyles.standardModalStyles}
                   onRequestClose={cancelAction}
                   title={logsFor
                       ? (
                           <span className="webhooks-modal__title">
                               {/* back to the list, not out of the dialog - the
                                   cross at the corner still does that */}
                               <button
                                   type="button"
                                   className="webhooks-modal__back"
                                   onClick={() => this.setState({logsFor: null})}
                               >
                                   <ChevronLeftIcon width={16} height={16} stroke="currentColor" strokeWidth={2}/>
                               </button>
                               <Translate text="webhookLogs"/>
                           </span>
                       )
                       : <React.Fragment><Translate text="webhooks"/> ({webhooks.length})</React.Fragment>}
                   description={logsFor ? logsFor.api : null}>

                {logsFor && <WebhookLogs webhook={logsFor}/>}

                <div hidden={!!logsFor}>
                    <TableScroll style={styles.parentTableDiv} stickyActions>
                        <table className="custom-table webhooks-table">
                            <colgroup>
                                <col className="webhooks-table__url-column"/>
                                <col className="webhooks-table__header-column"/>
                                <col className="webhooks-table__value-column"/>
                                <col className="webhooks-table__type-column"/>
                                <col className="webhooks-table__actions-column"/>
                            </colgroup>
                            <thead>
                            <tr>
                                <th
                                    key={'URL'}
                                >
                                    <Translate text={'url'}/>
                                </th>
                                <th
                                    key={'headerName'}
                                >
                                    <Translate text={'headerName'}/>
                                </th>
                                <th
                                    key={'value'}
                                >
                                    <Translate text={'value'}/>
                                </th>
                                <th
                                    key={'type'}
                                >
                                    <Translate text={'type'}/>
                                </th>
                                <th key={'actions'} aria-label="Actions"/>
                            </tr>
                            </thead>
                            <tbody>
                            {webhooksData.length === 0 && (
                                <tr className="table-no-result">
                                    <td colSpan={5} className="webhooks-table__empty">
                                        <Translate text="noResultsFound"/>
                                    </td>
                                </tr>
                            )}
                            {/* the row opens the calls, the way a row of the history opens a
                                conversation. The delete button stops the click itself, so it
                                still deletes rather than opening. */}
                            {[...webhooksData].sort((a, b) => a.id - b.id).map((webhook, index) => (
                                <tr key={index}
                                    className="border-td clickable-row"
                                    onClick={() => this.setState({logsFor: webhook})}>
                                    <td className="webhooks-table__url-cell">
                                        <Tooltip
                                            text={webhook.api}
                                            needTranslate={false}
                                            style={{width: '100%', minWidth: 0}}
                                        >
                                            <span className="webhooks-table__ellipsis">{webhook.api}</span>
                                        </Tooltip>
                                    </td>
                                    <td>{webhook.headerName}</td>
                                    <td>{webhook.token}</td>
                                    <td><WebhookTypeChip type={webhook.type}/></td>
                                    <td>
                                        <div className="table-actions">
                                            <TableAction
                                                tone="danger"
                                                tooltip={'remove'}
                                                onClick={() => {
                                                    deleteWebhook(webhook.companyId, webhook.id).then(() => {
                                                        setUpdateWebhooksState(!updateWebhooksState);
                                                        addNotification('deleted', config.notificationLevels.info);
                                                    }).catch(err => {
                                                        console.error("Error deleting webhook", err);
                                                        addNotification("somethingWentWrong", config.notificationLevels.error)
                                                    });
                                                }}
                                                icon={<DeleteIcon width={18} height={18} stroke={colors.red}/>}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </TableScroll>
                </div>

            </Modal>
        );
    }
}

WebhooksModal.propTypes = {};

export default WebhooksModal;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/webhooks/WebhooksModal.jsx